// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/licence-issuance-requirements.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/licence-issuance-requirements/licence-issuance-requirements.js';

mount([g0]);
